import { render, staticRenderFns } from "./AddLightCourseLessonModal.vue?vue&type=template&id=cc8a8778&"
import script from "./AddLightCourseLessonModal.vue?vue&type=script&lang=js&"
export * from "./AddLightCourseLessonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports